import type { interfaces } from '@patsnap/tahiti-core/shared/inversify';
import { ChemicalEntryService, ChemicalEntryServiceImpl } from './service/chemical-entry.service';

export const chemicalEntryModule = (bind: interfaces.Bind) => {
    bind(ChemicalEntryService).to(ChemicalEntryServiceImpl);
};
